import isEmpty from 'lodash/isEmpty';
import * as eventActions from '../actions/eventActions';
import * as navigationActions from '../actions/navigationActions';

const extendSegmentState = (state, { currentSegmentName, values = {} }) => ({
  ...state,
  [currentSegmentName]: {
    ...state[currentSegmentName],
    ...values,
  },
});

const handlePiggybankEvent = (state, { event, ...action }) => {
  switch (event.type) {
    case 'onNavigate': {
      const { values = {} } = event;

      if (!isEmpty(values)) {
        const { currentSegmentName } = action;

        return extendSegmentState(state, {
          currentSegmentName,
          values,
        });
      }
    }
  }

  return state;
};

export default (segmentNames, initialState = {}) => {
  const enrichedInitialState = segmentNames.reduce((acc, segmentName) => {
    if (!acc[segmentName]) {
      acc[segmentName] = {};
    }

    return acc;
  }, initialState);

  return (state = enrichedInitialState, action) => {
    switch (action.type) {
      case navigationActions.NEXT_SEGMENT:

      case navigationActions.PREV_SEGMENT:

      case navigationActions.NEXT_PAGE:

      case navigationActions.PREV_PAGE: {
        const { currentSegmentName, payload: values } = action;
        return extendSegmentState(state, { currentSegmentName, values });
      }

      case eventActions.PIGGYBANK_EVENT:
        return handlePiggybankEvent(state, action);

      default:
        return state;
    }
  };
};
